const defaultState = {
  OSCChannelsStatus: false
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_OSC_CHANNELS':
      return {
        ...state,
        OSCChannelsStatus: action.OSCChannelsStatus,
      }
    default:
      return state;
  };
};
